module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.5a561b1b.woff";